export * from './store/actions';
export * from './store/types';
export * from './queries';
export { default as LayoutHomepage } from '../pages/components/homepage/LayoutHomepage';
export { default as PagesPress } from '../pages/components/press/PagesPress';
export { default as PagesImprint } from '../pages/components/imprint/PagesImprint';
export { default as PagesTerms } from '../pages/components/terms/PagesTerms';
export { default as PagesPrivacy } from '../pages/components/privacy/PagesPrivacy';
export { default as PagesMarketing } from '../pages/components/marketing/PagesMarketing';
export { default as PagesSales } from '../pages/components/sales/PagesSales';
export { default as PagesPcon } from '../pages/components/pcon/PagesPcon';
export { default as PagesNewsletter } from '../pages/components/newsletter/PagesNewsletter';
export { default as PagesContactForm } from '../pages/components/contactForm/PagesContactForm';
export { default as PagesQuickship } from '../pages/components/quickship/PagesQuickship';
export { default as PagesNewsletterPreferences } from '../pages/components/newsletter/preferences/PagesNewsletterPreferences';
export * from '../pages/components/homepage/types';

export { default as reducer } from './store/reducers';
